/**
 * utils/token-storage.ts
 * STANDAR Indopoin — pattern dari RUNBOOK/04_SNIPPETS/frontend/token-storage.ts
 *
 * Simpan & ambil JWT token dari localStorage.
 * Token diterima dari Portal via ?access_token= setelah login.
 */

const TOKEN_KEY = 'app_access_token';   // STANDAR
const PORTAL_LOGIN_URL =
  (import.meta.env.VITE_PORTAL_LOGIN_URL as string) || 'https://app.indopoin.id/login';

export function getStoredToken(): string {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem(TOKEN_KEY) || '';
}

export function setStoredToken(token: string): void {
  if (typeof window === 'undefined') return;
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
}

export function clearStoredToken(): void {
  setStoredToken('');
}

/**
 * Extract token dari URL setelah redirect dari Portal.
 * Pattern STANDAR: Portal balik dengan ?access_token=... di URL.
 * Simpan ke localStorage, hapus dari URL (replaceState), return token.
 */
export function extractTokenFromURL(): string | null {
  if (typeof window === 'undefined') return null;

  const params = new URLSearchParams(window.location.search);
  const token = params.get('access_token');

  if (token) {
    setStoredToken(token);
    params.delete('access_token');
    const newQuery = params.toString();
    const newUrl = window.location.pathname + (newQuery ? `?${newQuery}` : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
    return token;
  }

  return null;
}

/**
 * Redirect ke Portal untuk login.
 * Pakai ?return_to=<current url> supaya Portal bisa redirect balik.
 */
export function redirectToLogin(returnTo?: string): void {
  if (typeof window === 'undefined') return;
  const target = returnTo || window.location.href;
  const url = `${PORTAL_LOGIN_URL}?return_to=${encodeURIComponent(target)}`;
  window.location.href = url;
}

/**
 * Logout — clear token + redirect ke Portal.
 */
export function redirectToLogout(): void {
  clearStoredToken();
  window.location.href = PORTAL_LOGIN_URL;
}